import { Pipe, PipeTransform } from '@angular/core';
import { DPFormField } from 'src/app/core/models/DPFormField';
import { DPFormFieldType } from 'src/app/core/models/enums/DPFormFieldType';

/**
 * Return column class for form fields based on colSpan property.
 */
@Pipe({
  name: 'itemClass',
  standalone: true,
})
export class ItemClassPipe implements PipeTransform {
  transform(field: DPFormField): string {
    if (field.type === DPFormFieldType.Multivalue) {
      return 'col-12';
    }

    const xl = field.colSpan?.desktop ? Math.min(field.colSpan?.desktop, 12) : 12;
    const md = field.colSpan?.tablet ? Math.min(field.colSpan?.tablet, 12) : 12;
    const xs = field.colSpan?.mobile ? Math.min(field.colSpan?.mobile, 12) : 12;

    return `d-block col-xl-${xl} col-md-${md} col-xs-${xs}`;
  }
}
